export default __webpack_public_path__ + "static/media/Board Level Committees.4b3e3d2e.pdf";